import * as React from "react";
import { IconProps } from "./IconProps";

export const IconBulkSelection = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.018 1.003C6.018 0.449058 6.46706 0 7.021 0H19.057C19.6109 0 20.06 0.449058 20.06 1.003V13.039C20.06 13.5929 19.6109 14.042 19.057 14.042H14.042V19.057C14.042 19.6109 13.5929 20.06 13.039 20.06H1.003C0.449058 20.06 0 19.6109 0 19.057V7.021C0 6.46706 0.449058 6.018 1.003 6.018H6.018V1.003ZM2.006 8.024V18.054H12.036V8.024H2.006ZM14.042 12.036V7.021C14.042 6.46706 13.5929 6.018 13.039 6.018H8.024V2.006H18.054V12.036H14.042Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7243 10.2704C11.0919 10.6308 11.0919 11.2153 10.7243 11.5758L6.48904 15.7296C6.31254 15.9027 6.07314 16 5.82353 16C5.57391 16 5.33452 15.9027 5.15802 15.7296L3.27566 13.8835C2.90811 13.523 2.90811 12.9385 3.27566 12.5781C3.64322 12.2176 4.23914 12.2176 4.60669 12.5781L5.82353 13.7715L9.39331 10.2704C9.76086 9.90988 10.3568 9.90988 10.7243 10.2704Z"
          fill={color}
        />
      </svg>
    );
  },
);
